import { useEffect, useState, useCallback } from 'react';
import { api } from './client';

export function useFriends() {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const refresh = useCallback(() => {
    setLoading(true);
    api.friends().then(r => setData(r.friends)).catch(e => setError(e.message)).finally(() => setLoading(false));
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return { data, loading, error, refresh };
}

export function useDeals() {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(() => {
    setLoading(true);
    api.deals().then(r => setData(r.deals)).catch(() => setData([])).finally(() => setLoading(false));
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return { data, loading, refresh };
}

export function useDeal(id: string | undefined) {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(() => {
    if (!id) return;
    setLoading(true);
    api.deal(id).then(setData).catch(() => setData(null)).finally(() => setLoading(false));
  }, [id]);
  useEffect(() => { refresh(); }, [refresh]);
  return { data, loading, refresh };
}

export function useHangs() {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(() => {
    setLoading(true);
    api.hangs().then(r => setData(r.hangs)).catch(() => setData([])).finally(() => setLoading(false));
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return { data, loading, refresh };
}

export function useVault() {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(() => {
    setLoading(true);
    api.vault().then(r => setData(r.artifacts)).catch(() => setData([])).finally(() => setLoading(false));
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return { data, loading, refresh };
}

export function useFeed() {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(() => {
    setLoading(true);
    api.intelFeed().then(r => setData(r.events)).catch(() => setData([])).finally(() => setLoading(false));
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return { data, loading, refresh };
}

export function useAccountingSummary() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(() => {
    setLoading(true);
    api.accountingSummary().then(setData).catch(() => setData(null)).finally(() => setLoading(false));
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return { data, loading, refresh };
}

export function useAccountingAr(status?: string) {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(() => {
    setLoading(true);
    api.accountingAr(status).then(r => setData(r.payments)).catch(() => setData([])).finally(() => setLoading(false));
  }, [status]);
  useEffect(() => { refresh(); }, [refresh]);
  return { data, loading, refresh };
}

export function useAccountingAp(status?: string) {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(() => {
    setLoading(true);
    api.accountingAp(status).then(r => setData(r.payments)).catch(() => setData([])).finally(() => setLoading(false));
  }, [status]);
  useEffect(() => { refresh(); }, [refresh]);
  return { data, loading, refresh };
}

export function useDealPayments(dealId: string | undefined) {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(() => {
    if (!dealId) return;
    setLoading(true);
    api.dealPayments(dealId).then(r => setData(r.payments)).catch(() => setData([])).finally(() => setLoading(false));
  }, [dealId]);
  useEffect(() => { refresh(); }, [refresh]);
  return { data, loading, refresh };
}
